import React from 'react';

import {defaultTheme} from '@ibibo/build-theme';
import IconSelector from '@ibibo/icon-selector';

import ActivitiesIcon from '../../stories/Icons/Amenities/ActivitiesIcon';
import BanquetHallIcon from '../../stories/Icons/Amenities/BanquetHallIcon';
import BellboyService from '../../stories/Icons/Amenities/BellboyServiceIcon';
import CctvIcon from '../../stories/Icons/Amenities/CctvIcon';
import CleanRoomIcon from '../../stories/Icons/Amenities/CleanRoomIcon';
import ConferenceRoomIcon from '../../stories/Icons/Amenities/ConferenceRoomIcon';
import DailyHousekeeping from '../../stories/Icons/Amenities/DailyHousekeepingIcon';
import DailyNewspaper from '../../stories/Icons/Amenities/DailyNewspapeIcon';
import ElectricSmokeDetector from '../../stories/Icons/Amenities/ElectricSmokeDetectorIcon';
import HouseKeepingIcon from '../../stories/Icons/Amenities/HouseKeepingIcon';
import InternationalPlug from '../../stories/Icons/Amenities/InternationalPlugIcon';
import IronAndIroningBoard from '../../stories/Icons/Amenities/IronAndIroningBoard';
import MiniRefrigirator from '../../stories/Icons/Amenities/MiniRefrigiratorIcon';
import MoneyExchange from '../../stories/Icons/Amenities/MoneyExchangeIcon';
import Photocopy from '../../stories/Icons/Amenities/PhotocopyIcon';
import PowerBackupIcon from '../../stories/Icons/Amenities/PowerBackupIcon';
import Security from '../../stories/Icons/Amenities/SecurityIcon';
import SpeciallyAbledAssistance from '../../stories/Icons/Amenities/SpeciallyAbledAssistanceIcon';
import Telephone from '../../stories/Icons/Amenities/TelephoneIcon';
import Umbrella from '../../stories/Icons/Amenities/UmbrellaIcon';
import LaundryIcon from '../../stories/Icons/LaundryIcon';
import RoundedCheckbox from '../../stories/Icons/RoundedCheckbox';

const AmenitiesIconSelector = ({
  name = '',
  styleProps,
}: {
  name: string;
  styleProps?: {
    [k: string]: string; // better typescript – 🐨 css properties
  };
}) => {
  if (!name) return <RoundedCheckbox {...styleProps} />;

  switch (name.trim().toLowerCase()) {
    case 'umbrella':
    case 'umbrellas':
      return <Umbrella {...styleProps} />;

    case 'international plug':
      return <InternationalPlug {...styleProps} />;

    case 'mini refrigerator':
      return <MiniRefrigirator {...styleProps} />;

    case 'security':
      return <Security {...styleProps} />;

    case 'telephone':
      return <Telephone {...styleProps} />;

    case 'doctor on call':
      return <IconSelector iconKey='doctoroncall' props={{...styleProps}} />;

    case 'money exchange facility':
      return <MoneyExchange {...styleProps} />;

    case 'elevator/lift':
    case 'elevators':
      return <IconSelector iconKey='lift' props={{...styleProps}} />;

    case 'bathroom':
      return <IconSelector iconKey='privatebath' props={{...styleProps}} />;

    case 'private safe box':
    case 'safe':
    case 'electronic safe locker':
      return <IconSelector iconKey='safe' props={{...styleProps}} />;

    case 'electronic smoke detector':
      return <ElectricSmokeDetector {...styleProps} />;

    case 'photocopying':
      return <Photocopy {...styleProps} />;

    case 'daily newspaper':
    case 'newspaper':
      return <DailyNewspaper {...styleProps} />;

    case 'iron and ironing board':
    case 'iron / ironing board available':
      return <IronAndIroningBoard {...styleProps} />;

    case 'bellboy service':
      return <BellboyService {...styleProps} />;

    case 'wheelchairs available':
      return <IconSelector iconKey='wheelchair' props={{...styleProps}} />;

    case 'tv with cable channels':
    case 'led/lcd cable tv':
      return <IconSelector iconKey='tv' props={{...styleProps}} />;

    case 'specially-abled assistance':
      return <SpeciallyAbledAssistance {...styleProps} />;
      
    case 'room service':
      return <IconSelector iconKey='roomservice' props={{...styleProps}} />;

    case 'dining':
    case 'dining area':
    case 'restaurant':
    case 'restaurant/coffee shop':
    case 'kitchen':
      return <IconSelector iconKey='restro' props={{...styleProps}} />;

    case 'parking facility':
    case 'free parking area':
    case 'free parking area':
    case 'parking facility':
      return <IconSelector iconKey='parking' props={{...styleProps}} />;

    case 'free internet':
    case 'free wifi':
    case 'wifi':
    case 'complimentary wifi':
      return <IconSelector iconKey='freewifi' props={{...styleProps}} />;

    case 'housekeeping':
    case 'laundry service':
    case 'laundry service (at a charge)':
      return <HouseKeepingIcon {...styleProps} />;

    case 'banquet hall':
      return <BanquetHallIcon {...styleProps} />;

    case 'cctv':
    case 'cctv surveillance':
      return <CctvIcon {...styleProps} />;

    case 'clean room':
      return <CleanRoomIcon {...styleProps} />;

    case 'power backup':
      return <PowerBackupIcon {...styleProps} />;

    case 'conference room':
      return <ConferenceRoomIcon {...styleProps} />;

    case 'room service':
      return <IconSelector iconKey='roomservice' props={{...styleProps}} />;

    case 'caretaker':
    case 'daily housekeeping':
      return <DailyHousekeeping {...styleProps} />;

    case 'laundry service':
    case 'laundry Service (At a charge)':
      return <LaundryIcon {...styleProps} />;

    case 'spa':
      return <IconSelector iconKey='spa' props={{...styleProps}} />;

    case 'outdoor sports':
    case 'outdoor activities':
      return <ActivitiesIcon {...styleProps} />;

    case 'swimming':
    case 'swimming pool':
      return <IconSelector iconKey='swimmingpool' props={{...styleProps}} />;

    case 'airport transfer (surcharge)':
    case 'travel assistance':
      return <IconSelector iconKey='pickup' props={{...styleProps}} />;

    case 'gym/fitness centre':
      return <IconSelector iconKey='gym' props={{...styleProps}} />;

    default:
      return <RoundedCheckbox {...{
        width: '1.5rem',
        height: '2.5rem',
        margin: '0 0.5rem 0 0',
        fill: defaultTheme.colors.grey.base
      }} />;
  }
};

export default AmenitiesIconSelector;
